import getPrintStyles from './InvoicePrintStyles';

const generatePrintContent = (invoiceData) => {
    return `
    <!DOCTYPE html>
    <html>
      <head>
        <title>Invoice #${invoiceData.invoiceNo}</title>
        <style>
          ${getPrintStyles()}
        </style>
      </head>
      <body>
        <!-- Company Header -->
        <div class="invoice-company-header">
          <canvas id="invoice-logo" width="80" height="60" class="company-logo"></canvas>

          <div class="company-header-info">
              <h1>W. THOMAS & SONS</h1>
              <h2>GUN CARE CENTRE - DAMBULLA</h2>
              
              <div class="branch-address-wrapper">
                <div class="branch-info">
                  <h3>Dambulla Branch</h3>
                  <p>Dambulugama, Anuradhapura Road, Dambulla</p>
                  <p>Tel: 066-4933042</p>
                  <p>Hotline: 0777 319250</p>
                  <p>E-mail: wthomasandsons@gmail.com</p>
                </div>

                <div class="branch-info">
                  <h3>Main Branch</h3>
                  <p>No. 323/3, Ihala Biyanwila, Kadawatha</p>
                  <p>Tel: 011-4361961, 011-4968626</p>
                  <p>Fax: 011 2972608</p>
                </div>
              </div>
          </div>

          <div class="header-spacer"></div>

          <script>
            window.onload = function() {
                const canvas = document.getElementById('invoice-logo');
                const ctx = canvas.getContext('2d');
                const img = new Image();
                img.src = 'images/logo.png';
                img.onload = function() {
                    ctx.drawImage(img, 0, 0, 80, 60);
                };
            };
          </script>
        </div>
        
        <!-- Invoice Title -->
        <div class="invoice-title">SALES RECEIPT</div>

        <!-- Invoice Header Section -->
        <div class="invoice-header-section">
          <!-- Customer Info -->
          <div class="sold-to-section">
            <div class="sold-to-header">Sold To</div>
            <div class="sold-to-box">
              <div class="sold-to-content">
                ${invoiceData.customerName}<br>
                ${invoiceData.customerAddress ? invoiceData.customerAddress.split(',').join('<br>') : ''}<br>
                ${invoiceData.customerPhone ? invoiceData.customerPhone : ''}
              </div>
            </div>
          </div>

          <!-- Invoice Details -->
          <div class="invoice-details-section">
            <table class="invoice-info-table">
              <tr>
                <td class="info-label">Date</td>
                <td>${invoiceData.date}</td>
              </tr>
              <tr>
                <td class="info-label">Rec No.</td>
                <td>${invoiceData.invoiceNo}</td>
              </tr>
              <tr>
                <td class="info-label">ID No.</td>
                <td>${invoiceData.customerNic || ''}</td>
              </tr>
            </table>
          </div>
        </div>

        <!-- Invoice Items -->
        <table class="invoice-table">
          <thead>
            <tr>
              <th class="description-col">Description</th>
              <th class="qty-col">Qty</th>
              <th class="rate-col">Rate</th>
              <th class="amount-col">Amount</th>
            </tr>
          </thead>
          <tbody>
            ${invoiceData.items && invoiceData.items.map((item, index) => `
              <tr key=${index}>
                <td class="description-col">${item.name}</td>
                <td class="qty-col">${item.quantity}</td>
                <td class="rate-col">${parseFloat(item.unitPrice).toFixed(2)}</td>
                <td class="amount-col">${parseFloat(item.totalPrice).toFixed(2)}</td>
              </tr>
            `).join('')}
          </tbody>
        </table>

        <!-- Serial Number -->
        ${invoiceData.serialNumber ? `
          <div class="serial-number-section">
            <div class="serial-label">Serial No</div>
            <div style="padding: 5px;">${invoiceData.serialNumber}</div>
          </div>
        ` : ''}

        <!-- Total -->
        <div class="total-section">
          <div class="total-row">
            <strong>Total &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Rs.${parseFloat(invoiceData.grandTotal).toFixed(2)}</strong>
          </div>
        </div>

        <!-- Bank Details -->
        <div class="bank-details">
          <h4>Our Bank Details :-</h4>
          <p><strong>(1) Bank of Ceylon - Kadawatha Super Grade Branch</strong></p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;W.Thomas and Sons Gun care Center</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;A/c No :- 9443334</p>
          <p><strong>(2) Commercial Bank - Kadawatha Branch</strong></p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;W.Thomas and Sons Gun care Center</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;A/c No :- 1670006682</p>
        </div>

        <!-- Signature Section -->
        <div class="signature-section">
          <div class="signature-text">Yours faithfully,</div>
          <div class="signature-line"></div>
          <div class="signature-name">R.P.Thomas</div>
          <div class="signature-title">MANAGER</div>
        </div>
        
        <!-- Terms & Conditions -->
        <div class="invoice-terms">
          <div class="terms-title">Goods once sold will not be accepted</div>
          <div class="terms-content">
            Manufacturers of weapon spares for small & heavy arms for military & civilian arms. Authorized 
            agents for Smith & Wesson, Hatsan, China Industries, Anshutz, Cometa / Service Center in Sri Lanka.
          </div>
        </div>
        
      </body>
    </html>
    `;
};

export default generatePrintContent;